import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardTitle,
  CardHeader,
  CardBody,
  Row,
  Col,
  Form,
  Input,
  FormGroup,
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import image from "Main_Image.jpg";
import { updateUserHandler } from "loginHandler/updateuser";

async function updateUser() {
  //get the username and password
  let id = sessionStorage.getItem("user_id");
  let email = document.getElementById('email').value;
  let firstName = document.getElementById('firstName').value;
  let lastName = document.getElementById('lastName').value;
  let password = document.getElementById('password').value;

  updateUserHandler(id, email, firstName, lastName, password).then((resp) => {
    if(resp){
      sessionStorage.setItem("email", email);
      sessionStorage.setItem("fullname", firstName + ' ' + lastName);
      window.location.href = "/admin/dashboard"
    }
  });

}

function User() {
  // set vars for the above
  const email = sessionStorage.getItem("email");
  const fullname = sessionStorage.getItem("fullname");
  const customer_name = sessionStorage.getItem("customer_name");

  //split full name into first and last name
  const name = fullname.split(' ');
  const firstName = name[0];
  const lastName = name[1];

  return (
    <>
      <PanelHeader
        size="lg"
        content={image}
      />
      <div className="content" style={{ marginTop: '-240px' }}>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">User Profile</CardTitle>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col className="pr-1" md="6">
                      <FormGroup>
                        <label>Company (disabled)</label>
                        <Input
                          // defaultValue="JCW Subcontractor 1"
                          value={customer_name}
                          disabled
                          placeholder="Company"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pl-1" md="6">
                      <FormGroup>
                        <label htmlFor="exampleInputEmail1">
                          Email address
                        </label>
                        <Input placeholder="Email" type="email" id="email" defaultValue={email} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <FormGroup>
                        <label>First Name</label>
                        <Input
                          defaultValue={firstName}
                          placeholder="Company"
                          type="text"
                          id="firstName"
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pl-1" md="6">
                      <FormGroup>
                        <label>Last Name</label>
                        <Input
                          defaultValue={lastName}
                          placeholder="Last Name"
                          type="text"
                          id="lastName"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <FormGroup>
                        <label>Set New Password</label>
                        <Input
                          defaultValue={""}
                          placeholder=""
                          type="text"
                          id="password"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <Button
                        onClick={() => updateUser()}
                        className="btn-round btn btn-success float-right"
                      >Save</Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default User;
